import { Truck, Package, BadgePercent, MessageCircle, Phone } from "lucide-react";
import { IMAGES } from "../lib/data";
import { useContact } from "../contexts/ContactContext";

const POINTS = [
  {
    icon: BadgePercent,
    title: "Wholesale Rates",
    desc: "Seedha factory daam — bichke buyer ki bachat.",
  },
  {
    icon: Package,
    title: "Bulk Quantity Ready",
    desc: "Detergent powder, sabun, phenyl — boriyon mein available.",
  },
  {
    icon: Truck,
    title: "Local Delivery",
    desc: "Bhiwandi mein delivery & nikat shahron tak transport.",
  },
];

export const Wholesale = () => {
  const { openGate } = useContact();
  
  return (
    <section
      id="wholesale"
      data-testid="wholesale-section"
      className="section-pad"
    >
      <div className="msc-container">
        <div className="grid lg:grid-cols-12 gap-10 items-center">
          {/* Left content */}
          <div className="lg:col-span-7">
            <span className="badge-trust">Bulk · Retail Owners</span>
            <h2 className="mt-3 font-display font-black text-3xl sm:text-4xl lg:text-5xl text-[#1F2937] leading-tight">
              <span className="text-[#1E3A8A]">Wholesale</span> ke liye{" "}
              <br className="hidden sm:block" />
              direct hum se baat kijiye.
            </h2>
            <p className="mt-4 text-base sm:text-lg text-[#4B5563] max-w-xl">
              Kirana store, society, society canteen, ya factory — bulk quantity
              chahiye toh asli wholesale rate hum se milega. Kam margin, lambi
              dosti.
            </p>

            <div className="mt-7 grid sm:grid-cols-3 gap-3 sm:gap-4">
              {POINTS.map((p) => (
                <div
                  key={p.title}
                  data-testid={`wholesale-point-${p.title.toLowerCase().replace(/\s+/g, "-")}`}
                  className="card-base p-4"
                >
                  <div className="w-10 h-10 rounded-lg bg-[#1E3A8A]/10 text-[#1E3A8A] flex items-center justify-center mb-3">
                    <p.icon className="w-5 h-5" />
                  </div>
                  <h3 className="font-display font-bold text-sm text-[#1F2937]">
                    {p.title}
                  </h3>
                  <p className="text-xs text-[#4B5563] mt-1 leading-snug">
                    {p.desc}
                  </p>
                </div>
              ))}
            </div>

            <div className="mt-7 flex flex-col sm:flex-row gap-3">
              <button
                onClick={() => openGate("Hello! Main wholesale rate aur bulk quantity ke baare mein details chahta/chahti hoon.")}
                data-testid="wholesale-whatsapp-btn"
                className="btn-whatsapp"
              >
                <MessageCircle className="w-5 h-5" /> Wholesale Enquiry
              </button>
            </div>
          </div>

          {/* Right image */}
          <div className="lg:col-span-5 relative">
            <div className="absolute -top-5 -right-5 w-28 h-28 rounded-2xl bg-[#F59E0B]/25 -z-10" />
            <img
              src={IMAGES.wholesale}
              alt="Wholesale bulk products warehouse"
              loading="lazy"
              className="rounded-2xl shadow-xl w-full object-cover aspect-[4/5]"
              data-testid="wholesale-image"
            />
            <div className="absolute -bottom-5 -left-5 bg-white rounded-xl shadow-xl p-4 flex items-center gap-3 max-w-[260px]">
              <div className="w-12 h-12 rounded-lg bg-[#25D366]/15 text-[#15803D] flex items-center justify-center">
                <Truck className="w-6 h-6" />
              </div>
              <div className="leading-tight">
                <div className="font-display font-bold text-sm text-[#1F2937]">
                  Same-Day Pickup
                </div>
                <div className="text-xs text-[#4B5563] mt-0.5">
                  Bhiwandi ke andar
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
